export default __webpack_public_path__ + "static/media/Geda_Logo.f237e862.jpg";